import request from '@/utils/request';

export function queryorderorg(params) {
  console.log('params',params);
  return request('/org_api/v1/insurance/queryorderorg', {
    method: 'get',
    params: {...params}//get请求使用params,直接拼接在请求url上
  })
}
export function insurance (params) {
  console.log('params',params);
  return request('/org_api/v1/insurance/insurance', {
    method: 'get',
    params: {...params}//get请求使用params,直接拼接在请求url上
  })
}
export function sendemail(params) {
  console.log('params',params);
  return request('/org_api/v1/insurance/sendemail', {
    method: 'get',
    params: {...params}//get请求使用params,直接拼接在请求url上
  })
}
export function orderrefund(params) {
  console.log('params',params);
  return request('/org_api/v1/insurance/orderrefund', {
    method: 'post',
    data: {...params}//get请求使用params,直接拼接在请求url上
  })
}
export function insuranceorderstatusselect(params) {
  console.log('params',params);
  return request('/org_api/v1/insurance/insuranceorderstatusselect', {
    method: 'get',
    params: {...params}//get请求使用params,直接拼接在请求url上
  })
}
